import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchRoleFeatures, updateRoleFeature, RoleFeature } from "src/services/roleFeatures.service";

export const doGetRoleFeatures = createAsyncThunk(
  "roleFeatures/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchRoleFeatures();
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch role features" }
      );
    }
  }
);

export const doUpdateRoleFeature = createAsyncThunk(
  "roleFeatures/update",
  async (
    { roleId, featureData }: { roleId: number; featureData: Partial<RoleFeature> },
    { rejectWithValue }
  ) => {
    try {
      const response = await updateRoleFeature(roleId, featureData);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to update role feature" }
      );
    }
  }
);